import { Metadata } from 'generated/apolloComponents'
import CustomHead from '@/components/molecules/CustomHead'
import SurveyLanding from '@/components/templates/SurveyLanding'
import surveyRoles from '@/data/surveyRoles'

interface IProps {
  options: any
}
export default function Survey({ options }: IProps) {
  const metaData = {
    title: 'Badanie Diversity w polskim IT 2025',
    description: 'Powiedz, na czym naprawdę polega różnorodność w polskim IT!',
    imageUrl: `https://${process.env.NEXT_PUBLIC_PL_HOST}/next-images/reports/diversity/share.png`,
  } as Metadata
  return (
    <>
      <CustomHead metaData={metaData} noindex />
      <SurveyLanding />
    </>
  )
}
export const getServerSideProps = async (context: any) => ({
  props: {},
})
